import { DEFAULT_RX_NOTE, RX_OPTED_IN_TITLE, RX_OPTED_OUT_TITLE } from "@cart-client/constants/RxInstructions";
import { BOOLEAN_AS_STRING, MROChildCart, ReviewedCartApiResponse } from "@swiggy-private/cart-types";

export const isOptedRx = (cartData: ReviewedCartApiResponse | MROChildCart | null): boolean =>
    cartData?.restaurant_details?.special_instructions_opted === true;

export const isInstructionsHalfcardEnabled = (cartData: ReviewedCartApiResponse | null): boolean =>
    cartData?.XPData?.si_half_card === BOOLEAN_AS_STRING.TRUE;

export const getRxInstructionTitle = (isOptedInRx: boolean): string =>
    isOptedInRx ? RX_OPTED_IN_TITLE : RX_OPTED_OUT_TITLE;

export const getRxNote = (cartData: ReviewedCartApiResponse | MROChildCart | null | undefined): string =>
    cartData?.restaurant_details?.restaurant_special_instruction ?? DEFAULT_RX_NOTE;
